import { cn } from "@theprelude/core";

export const DefenderIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 24 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 11.1406V2.23608C13.0589 2.2434 13.1274 2.25248 13.2071 2.26333C13.722 2.33703 14.2369 2.47032 14.7116 2.6528C15.1243 2.81423 15.2374 2.87053 15.7962 3.20742C17.4725 4.21808 18.9811 4.58977 21.7494 4.6775L21.9866 4.68446L21.9976 7.47456C22.0086 10.2083 21.9832 11.0048 21.8919 11.1101L13 11.1406ZM13 22.0601V13.2133H21.4318C21.256 13.7059 20.9903 14.3108 20.7196 14.8087C19.9965 16.1317 19.1562 17.2164 17.8962 18.4551C16.8079 19.5219 15.7343 20.3603 14.2369 21.3114C13.7987 21.5886 13.3748 21.8521 13.2944 21.8977C13.1759 21.9637 13.0791 22.0172 13 22.0601ZM2.57111 13.2133H11V22.0546C10.3998 21.7411 9.08677 20.8974 8.30935 20.3077C6.7718 19.1356 5.45336 17.876 4.48554 16.6513C3.6741 15.6195 2.96343 14.34 2.57111 13.2133ZM11 2.24116V11.1418H2.08259L2.03851 10.7207C2.00564 10.4189 1.99488 9.50627 2.00218 7.49197L2.00953 4.68446L2.37485 4.6775C3.6531 4.64942 5.0955 4.47061 5.95376 4.22847C6.84123 3.97931 7.41112 3.723 8.27303 3.19311C9.09476 2.68778 9.76684 2.43514 10.7201 2.28074C10.8151 2.26499 10.9138 2.25138 11 2.24116Z"
    />
  </svg>
);
